import React from 'react';
import classnames from 'classnames/bind';
import PageLink from 'components/PageLink/PageLink';
import styles from './CardItem.module.scss';

interface Props {
  heading: string;
  paragraphs?: string[];
  list?: string[];
  warning?: string[];
  onClick?: () => void;
  buttonUrl?: string;
  buttonText?: string;
  disabled?: boolean;
  style?: any;
}

const CardItem = ({
  heading,
  paragraphs,
  list,
  warning,
  onClick,
  buttonUrl,
  buttonText,
  disabled,
  style,
}: Props) => {
  return (
    <div className={styles.item} style={style}>
      <h3 className={styles.heading}>{heading}</h3>
      <div className={styles.cardContent}>
        {paragraphs &&
          (paragraphs || []).map((item) => item && (
            <p
              className={styles.paragraph}
              dangerouslySetInnerHTML={{ __html: item }}
            />
          ))}
        {list && (
          <ul className={styles.list}>
            {(list || []).map((item) => (
              <li className={styles.listItem}>{item}</li>
            ))}
          </ul>
        )}
        {warning &&
          (warning || []).map(
            (item) =>
              item && (
                <p
                  className={styles.paragraph}
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              ),
          )}
      </div>
      {onClick && buttonText && (
        <button onClick={() => onClick()} className={styles.link}>
          {buttonText}
        </button>
      )}
      {buttonText &&
        buttonUrl &&
        <PageLink
          url={buttonUrl!}
          text={buttonText}
          className={classnames(styles.link, disabled && styles.disabledLink)}
          disabled={disabled}
        />
      }
    </div>
  );
};

export default CardItem;
